import { Loading } from 'apps/builder/components/shared/animations'

export const LoadingPDF = () => (
    <>
        <Loading />
        <h3 className="t-center">Creating your PDF...</h3>
    </>
)

export const CustomLoadingPDF = ({
    logoUrl,
    alt,
    loadingText = 'Creating your PDF...'
}) => () => (
    <div className="loading--logo custom">
      <img cdn="true" src={logoUrl} alt={alt}/>
      <h3 className="t-center">{loadingText}</h3>
    </div>
)